import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const DesiginationClient = () => {
  return (
    <SettingsMetaData propertyName={"desigination"} viewPropertyName={"Designation"} />
  );
};
export default DesiginationClient;